module.exports = __webpack_public_path__ + "img/four4Blue.3b78004e.jpg";